<template>
  <component-wrapper
    :key="catalogId"
    class="product-detail-page-fi"
  >
    <product-detail-head-fi
      :catalog-data="getCatalogProductDataById"
      :media-download-link="mediaDownloadLink"
      :fields="fields"
      :no-margin-bottom="Boolean(accessories?.length)"
      @added-to-memolist="addedToMemoList"
    />

    <product-items-slider-fi
      v-if="accessories?.length"
      :product-items="accessories"
      :slider-headline="$dict.get('product-Family.Accessories.Headline')"
      white
      expandable
    />

    <product-detail-accordions-fi
      :fields="fields"
      :catalog-data="getCatalogProductDataById"
    />

    <section-divider-small-fi />

    <cross-selling-product-teasers-fi
      v-if="fields.crossSellingProductTeaserEnabled?.value"
      :product-ids="getCatalogProductDataById.ProductId"
    />

    <product-detail-schema-fi
      v-if="getCatalogProductDataById"
      :catalog-data="getCatalogProductDataById"
    />
  </component-wrapper>
</template>

<script>
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import CrossSellingProductTeasersFi from '@/components/cross-selling-product-teasers-fi/CrossSellingProductTeasersFi.vue';
import ProductDetailAccordionsFi from '@/components/product-detail/product-detail-accordions-fi/ProductDetailAccordionsFi.vue';
import ProductDetailHeadFi from '@/components/product-detail/product-detail-head-fi/ProductDetailHeadFi.vue';
import ProductDetailSchemaFi from '@/components/product-detail/product-detail-schema-fi/ProductDetailSchemaFi.vue';
import ProductItemsSliderFi from '@/components/product-items-slider-fi/ProductItemsSliderFi.vue';
import GET_CATALOG_PRODUCT_DATA_BY_ID from '@/graphql/getCatalogProductDataById.gql';
import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogMixin from '@/mixins/catalogMixin.vue';
import trackingMixin from '@/mixins/trackingMixin.vue';
import SectionDividerSmallFi from '@/pages/section-divider-fi/SectionDividerSmallFi.vue';

export default {
  name: 'ProductDetailPageFi',
  components: {
    ComponentWrapper,
    ProductDetailHeadFi,
    ProductDetailAccordionsFi,
    SectionDividerSmallFi,
    ProductItemsSliderFi,
    CrossSellingProductTeasersFi,
    ProductDetailSchemaFi,
  },
  mixins: [breakpointMixin, catalogMixin, trackingMixin],
  inject: ['fields'],
  data() {
    return {
      getCatalogProductDataById: {},
    };
  },
  computed: {
    catalogId() {
      return this.$fischer.catalogId('040390');
    },
    accessories() {
      return this.getCatalogProductDataById?.accessories;
    },
  },
  created() {
    if (this.catalogId) {
      this.checkForMediaDownload({
        type: 'product',
        id: this.catalogId,
      });
    }

    this.handleEventTracking();
  },
  apollo: {
    getCatalogProductDataById: {
      query: GET_CATALOG_PRODUCT_DATA_BY_ID,
      errorPolicy: 'all',
      variables() {
        return {
          baseSiteId: this.$fischer.baseSiteId(),
          apiLang: this.$fischer.catalogLocale(),
          id: this.catalogId,
        };
      },
      result({ data }) {
        if (data?.getCatalogProductDataById) {
          this.trackViewItem(data.getCatalogProductDataById);
        }
      },
      skip() {
        return !this.catalogId;
      },
      error() {
        this.error = true;
      },
    },
  },
  methods: {
    addedToMemoList() {
      if (this.getCatalogProductDataById) {
        this.trackAddProductToWishlist(this.getCatalogProductDataById);
      }
    },
    handleEventTracking() {
      if (IS_SSR) {
        return;
      }

      try {
        const recommendationClickDetails = localStorage.getItem('recommendationClick');
        if (recommendationClickDetails) {
          const { refererId, itemQuantity, guided } = JSON.parse(recommendationClickDetails);
          this.sendEvent(guided ? 'guided_recommendation_click' : 'recommendation_click', {
            url: window ? window.location.href : '',
            productId: this.catalogId,
            refererId,
            itemQuantity,
          });

          localStorage.removeItem('recommendationClick');
        }
      } catch (error) {
        console.debug('failed to process recommendation click', error);
      }
    },
  },
};
</script>

<style scoped src="./product-detail-page-fi" />
